// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wifi-button[data-v-52438d32]{align-items:center;background:hsla(0,0%,100%,.4);border:none;border-radius:11px;color:#fff;cursor:pointer;display:flex;font-size:15px;font-weight:500;height:40px;justify-content:center;margin-right:12px;min-width:60px;padding:0}.novikov .wifi-button[data-v-52438d32]{background:#fff;color:#ee1623}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
